import { format, toZonedTime } from "date-fns-tz";

export const convertTimeToLocalReadable = (time: Date) => {
  //TODO: switch to dynamic zone for later
  const zonedDate = toZonedTime(time, "CET");
  return format(zonedDate, "yyyy-MM-dd HH:mm:ss", { timeZone: "CET" });
};
